//----------------------------------------------------Library
import React, { useEffect, useMemo, useState } from "react";
import { Button, Checkbox, CircularProgress, FormControlLabel, Grid, Typography, Link, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { withStyles } from "@material-ui/core/styles";
import { Element, scroller } from 'react-scroll';
//----------------------------------------------------redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AccountActions from "../Actions/AccountActions";
import * as ProcessActions from "../Actions/ProcessActions";
//----------------------------------------------------Utils
import { createDemoAccount } from "../Utils";
import { validateFields } from "../Utils/models";
import { verifyEmailAddress } from "../Utils/MFA";
//----------------------------------------------------Constants
import { SCROLL_OFFSET } from "../Constants";

const styles = (theme) => ({
  nextBtn: {
    margin: "10px 0 10px 0",
    height: "3rem",
    backgroundColor: '#155E98',
  },
  cartIcon: { color: "white" },
  cartHeader: {
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    gridGap: "6px",
    marginTop: "10px",
  },
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": {
      fontSize: "1.2em",
    },
    "& legend": {
      fontSize: "0.78em",
    },
  },
})(TextField);

const SNACKBAR_INIT_VALUE = {
  open: false,
  type: "error",
  message: ""
};

const initailErrorForm = {
  firstName: { hasError: false },
  lastName: { hasError: false },
  email: { hasError: false },
  number: { hasError: false },
  country: { hasError: false },
  username: { hasError: false },
  password: { hasError: false },
  passwordConfirm: { hasError: false },
  street: { hasError: false },
  address: { hasError: false },
  suburb: { hasError: false },
  state: { hasError: false },
  postalCode: { hasError: false },
  day: { hasError: false },
  month: { hasError: false },
  year: { hasError: false },
  hasTraded: { hasError: false },
  tradedProducts: { hasError: false },
  tradeFrequency: { hasError: false },
  broker: { hasError: false },
  hearAboutUs: { hasError: false },
};

const fields = ["firstName", "lastName", "number", "country"];
const allFields = ["email", "username", "password", "firstName", "lastName", "number", "country"];

const inputFieldDetails = {
  firstName: { autoComplete: 'given-name', label: 'First Name' },
  lastName: { autoComplete: 'family-name', label: 'Last Name' },
  number: { autoComplete: 'number', label: 'Phone Number' },
};

const StepTwo = (props) => {
  const [userAccount, setUserAccount] = useState(props.userAccount);
  const [formErrors, setFormErrors] = useState(initailErrorForm);
  const [goingNextStep, setGoingNextStep] = useState(false);
  const [agreedOne, setAgreedOne] = useState(false);
  const [agreedTwo, setAgreedTwo] = useState(false);
  const [agreedThree, setAgreedThree] = useState(false);
  const [agreedFour, setAgreedFour] = useState(false);

  useEffect(() => {
    setUserAccount(props.userAccount);
  }, [props.userAccount]);

  useEffect(() => {
    if (goingNextStep === true) {
      let errorFields = Object.entries(formErrors).filter(([field, { hasError }]) => hasError && allFields.includes(field));
      if (errorFields.length === 0) {
        props.actions.nextStep();
        setTimeout(() => setGoingNextStep(false), 1000);
      } else {
        setGoingNextStep(false)
      }
    }
  }, [goingNextStep]);

  useEffect(() => {
    if (goingNextStep === true) {
      let errorFields = Object.entries(formErrors).filter(([field, { hasError }]) => hasError && fields.includes(field));
      if (errorFields.length === 0) {
        props.actions.nextStep();
        setTimeout(() => setGoingNextStep(false), 1000);
      } else {
        setGoingNextStep(false)
      }
    }
  }, [goingNextStep])

  const { classes, loading } = useMemo(() => {
    return { classes: props.classes, loading: props.loading }
  }, [props.classes, props.loading]);

  const userDetails = userAccount.details;

  const countries = useMemo(() => {
    return props.countries;
  }, [props.countries])

  const countryValueLabel = useMemo(() => {
    return countries.find(c => c.value === userDetails.address.country) || null;
  }, [countries, userDetails.address.country])


  const onChange = (field, value) => {
    if (field === 'country') {
      setUserAccount({ ...userAccount, details: { ...userAccount.details, address: { country: value } } });
    } else {
      setUserAccount({ ...userAccount, details: { ...userAccount.details, [field]: value } });
    }
  };

  const onAutoFill = (field, value) => {
    // if(prevValue === "" || !prevValue) props.accountActions.updateUserAccount(field, value);
    if (field === 'country') {
      setUserAccount({ ...userAccount, details: { ...userAccount.details, address: { country: value } } });
    } else {
      setUserAccount({ ...userAccount, details: { ...userAccount.details, [field]: value } });
    }
  };

  const onValidateField = (field) => {
    // const { userAccount } = props;
    const details = userAccount.details;

    const values = {};

    if (userAccount[field]) {
      values[field] = userAccount[field];
      if (field === 'passwordConfirm') values['password'] = userAccount['password'];
    } else if (details[field]) {
      values[field] = details[field];
    } else if (details.address[field]) {
      values[field] = details.address[field];
    }

    setFormErrors(validateFields([field], values, formErrors));
  };

  const getCountryValue = (label) => {
    if (!label) return "0";
    let country = countries.find(c => c.label.toLowerCase() === label.toLowerCase().trim());
    return country ? country.value : "0";
  };

  const onAutoCompleteBlur = (e, prevValue) => {
    const newValue = getCountryValue(e.target.value);
    if (prevValue !== newValue && newValue !== "0") {
      setUserAccount({ ...userAccount, details: { ...userAccount.details, address: { country: newValue } } });
      setTimeout(() => onValidateField("country"), 200);
    } else {
      setFormErrors(validateFields(["country"], { country: newValue }, props.formErrors));
    }

  };

  const scrollToElement = (elementName) => {
    scroller.scrollTo(elementName, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: SCROLL_OFFSET
    });
  };

  const onCreateDemoAccount = async () => {

    const { actions, accountActions, openSnackbar } = props;
    try {
      const details = userAccount.details || {};
      const values = allFields.reduce((final, field) => {
        if (userAccount[field] !== undefined) final[field] = userAccount[field];
        else if (details[field] !== undefined) final[field] = details[field];
        else if (details.address[field] !== undefined) final[field] = details.address[field];

        return final;
      }, {});

      if (!agreedOne || !agreedTwo || !agreedThree || !agreedFour) {
        openSnackbar(null);
        openSnackbar({
          type: "error",
          open: true,
          message: 'Please accept all Terms & Conditions',
          duration: 4000
        });
        return;
      } else {
        const countryObj = countries.find(c => c.value === values['country']) || null;
        const countryName = countryObj ? countryObj.label : '';
  
        const newFormErrors = validateFields(fields, values, formErrors);
        const errorFields = Object.entries(newFormErrors).filter(([field, { hasError }]) => hasError && fields.includes(field));
  
        if (Object.keys(newFormErrors).filter(key => fields.includes(key)).some(key => newFormErrors[key] && newFormErrors[key].hasError)) {
          let elementName = `${errorFields[0][0]}`;
          scrollToElement(`element-${elementName}`);
          return setFormErrors(newFormErrors);
        }
  
        values['country'] = countryName;

        let ibId = '';

        const queryString = window.parent.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (queryString.length && urlParams.get('ib')) {
          ibId = urlParams.get('ib');
        }
        
        values['ibId'] = ibId;

        actions.setLoading(true);
        const { ok, userAccount: newAccount, ...rest } = await createDemoAccount({ ...values });
  
        if (ok) {
          const result = await verifyEmailAddress(newAccount.email, newAccount.hashedPassword);
          if (result.ok) {
            openSnackbar(null);
            openSnackbar({
              type: "success",
              open: true,
              message: `Verification email has been send to your email address ${userAccount.email}, please check your email.`,
              duration: 4000
            });
          } else {
            openSnackbar(null);
            openSnackbar({
              type: "error",
              open: true,
              message: result.msg || 'Something went wrong. Please try again',
              duration: 4000
            });
          }
          accountActions.setUserAccount(newAccount);
          actions.setLoading(false);
          setGoingNextStep(true);
        } else {
          openSnackbar(null);
          openSnackbar({
            type: "error",
            open: true,
            message: rest.message || 'Something went wrong. Please try again',
            duration: 4000
          });
          actions.setLoading(false);
        }
        actions.setLoading(false);
      }
    } catch (error) {
      console.error(error);
      openSnackbar({
        type: "error",
        message: error.message,
        open: true,
      });
      actions.setLoading(false);
    }
  }


  const renderInputField = (field) => {
    if (field === 'country') {
      return;
    }

    return (
      <Grid item xs={12} key={field}>
        <Element name={`element-${field}`}>
          <TviTextFiled
            autoComplete={inputFieldDetails[field].autoComplete}
            required
            id={field}
            name={field}
            type={field === 'number' ? 'number' : 'string'}
            variant="outlined"
            fullWidth={true}
            defaultValue={userDetails[field] || ''}
            label={`${inputFieldDetails[field].label}${formErrors[field].hasError ? " (Invalid)" : ""}`}
            onChange={(e) => onChange(field, e.target.value)}
            onInput={(e) => onAutoFill(field, e.target.value)}
            onBlur={() => onValidateField(field)}
            error={formErrors[field].hasError}
            helperText={formErrors[field].hasError ? formErrors[field].errorMessage : ""}
          />
        </Element>
      </Grid>
    )
  }

  const renderForm = () => {

    const userAddress = userDetails.address || {};

    return (
      <form noValidate>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="stretch"
          spacing={2}
        >
          {fields.map(field => renderInputField(field))}

          <Grid item xs={12}>
            <Element name="element-country">
              <Autocomplete
                autoComplete={true}
                autoHighlight={true}
                autoSelect={true}
                value={countryValueLabel}
                options={countries}
                getOptionLabel={(option) => option.label}
                onChange={(e, v, r) => { onChange("country", v ? v.value : "0"); }}
                renderInput={(params) => (
                  <TviTextFiled
                    {...params}
                    variant="outlined"
                    fullWidth
                    inputProps={{ ...params.inputProps, "data-hj-allow": true }}
                    required
                    onBlur={(e) => onAutoCompleteBlur(e, (userAddress.country || 0))}
                    onInput={(e) => onAutoFill(e, "country", getCountryValue(e.target.value), (userAddress.country || 0) === 0 ? "" : " ")}
                    label={`Country Name${formErrors.country.hasError ? " (Invalid)" : ""}`}
                    error={formErrors.country.hasError}
                    helperText={formErrors.country.hasError ? formErrors.country.errorMessage : ""}
                  />
                )}
              />
            </Element>
          </Grid>
          <Grid item xs={12} style={{ textAlign: "left" }}>
            <p>You are applying for a CFD account. The purpose of the CFD account is for trading purposes only.</p>
            <p>CFD accounts are provided by Trade View Ltd which is a trading name of Trade View Technologies Ltd and 
              is a Securities Dealer registered in Seychelles with registration number 8431779-1 and authorised by the 
              Financial Services Authority (FSA) with licence number SD125
            </p>
            <FormControlLabel
              control={<Checkbox color="primary" checked={agreedOne} onChange={({ target }) => setAgreedOne(target.checked)} name="agreed" />}
              label={<Typography variant="body2">I understand the nature and risks associated with trading CFDs.</Typography>}
            />
            <FormControlLabel
              control={<Checkbox color="primary" checked={agreedTwo} onChange={({ target }) => setAgreedTwo(target.checked)} name="agreed" />}
              label={<Typography variant="body2">I hereby confirm that I have read, understand and agree to be bound by the terms of these.<Link href=" https://tradeview.tech/legal-documents/" target="_blank">Legal Documents</Link>.</Typography>}
            />
            <FormControlLabel
              control={<Checkbox color="primary" checked={agreedThree} onChange={({ target }) => setAgreedThree(target.checked)} name="agreedThree" />}
              label={<Typography variant="body2">I consent to receive emails from Trade View Group of companies about trading ideas, products and services. </Typography>}
            />
            <FormControlLabel
              control={<Checkbox color="primary" checked={agreedFour} onChange={({ target }) => setAgreedFour(target.checked)} name="agreedFour" />}
              label={<Typography variant="body2">I certify that the information given by me in this form is true and correct. </Typography>}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={onCreateDemoAccount}
              className={classes.nextBtn}
            >
              {loading ? <CircularProgress size={20} color='inherit' >&nbsp;Please Wait...</CircularProgress> : <Typography variant="h5">Create Account</Typography>}
            </Button>

            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={()=>props.actions.prevStep()}
              className={classes.nextBtn}
            >
              {loading ? <CircularProgress size={20} color='inherit' >&nbsp;Please Wait...</CircularProgress> : <Typography variant="h5">Back</Typography>}
            </Button>
          </Grid>
        </Grid>
      </form>
    )
  }

  return (
    <Grid container>
      {/* <Grid item xs={12} style={{ paddingBottom: "6px", marginBottom: "5px" }}>
        <Typography variant="h4" gutterBottom><strong>Create New Account</strong></Typography>
      </Grid> */}
      <Grid item xs={12}>
        {renderForm()}
      </Grid>
    </Grid>
  );
}

const mapStateToProps = ({ process, cartReducer, accountReducer }) => ({
  loading: process.loading,
  countries: process.countries,
  formErrors: process.formErrors,
  userAccount: accountReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ProcessActions, dispatch),
  accountActions: bindActionCreators(AccountActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StepTwo));